export const headerAgencyActivityTable = [
  {
    headerStyles: 'w-[5%] font-semibold py-5 px-4',
    rowWid: 'w-[5%] py-5 break-all pl-4 align-top',
    name: 'Id',
    label: 'agencyActivityId',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: true,
  },
  {
    headerStyles: 'w-[35%] font-semibold py-5 px-4',
    rowWid: 'w-[35%] py-5 break-all pl-2 align-top',
    name: 'Request',
    label: 'request',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[30%] font-semibold py-5 px-4',
    rowWid: 'w-[30%] py-5 break-all pl-2 align-top',
    name: 'Response',
    label: 'response',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[10%] font-semibold py-5 px-4',
    rowWid: 'w-[10%] py-5 break-all align-top pl-2',
    name: 'Status',
    label: 'status',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[25%] font-semibold py-5 px-4',
    rowWid: 'w-[25%] py-5 break-all pl-2 align-top',
    name: 'Created At',
    label: 'createdAt',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
  // {
  //   headerStyles: 'w-[3%] font-semibold py-5 px-4',
  //   rowWid: 'w-[5%] py-5 break-all align-top pl-2',
  //   name: 'Action',
  //   label: 'action',
  //   isFilter: true,
  //   isFilterDate: false,
  //   isOneLineRes: false,
  // },
]
